import {AbstractControl, ValidationErrors} from '@angular/forms';

import {AOValidations} from './ao-validations';

// @dynamic

export class AOValidators {

  static touched(control): any {
    if (control.pristine) {
      return true;
    }

    control.markAsTouched();

    return false;
  }

  static custom(callback) {
    return control => {
      return AOValidators.touched(control) || callback(control.value) ? null : {invalidCustom: true};
    };
  }

  // -------------------------------------------------------------------------------------------------------------------

  static email(control: AbstractControl): ValidationErrors | null {
    return AOValidators.touched(control) || AOValidations.isEmail(control.value) ? null : {invalidEmail: true};
  }

  static url(control: AbstractControl): ValidationErrors | null {
    return AOValidators.touched(control) || AOValidations.isUrl(control.value) ? null : {invalidUrl: true};
  }

  static phone(control: AbstractControl): ValidationErrors | null {
    return AOValidators.touched(control) || AOValidations.isPhone(control.value) ? null : {invalidPhone: true};
  }

  static phoneINTER(control: AbstractControl): ValidationErrors | null {
    return AOValidators.touched(control) || AOValidations.isPhoneINTER(control.value) ? null : {invalidPhone: true};
  }

  static zipCode(control: AbstractControl): ValidationErrors | null {
    return AOValidators.touched(control) || AOValidations.isZipCode(control.value) ? null : {invalidZip: true};
  }

  static zipCodeINTER(control: AbstractControl): ValidationErrors | null {
    return AOValidators.touched(control) || AOValidations.isZipCodeINTER(control.value) ? null : {invalidZip: true};
  }

  static cpf(control: AbstractControl): ValidationErrors | null {
    return AOValidators.touched(control) || AOValidations.isCpf(control.value) ? null : {invalidZip: true};
  }

  static cnpj(control: AbstractControl): ValidationErrors | null {
    return AOValidators.touched(control) || AOValidations.isCnpj(control.value) ? null : {invalidZip: true};
  }

  static cpfCnpj(control: AbstractControl): ValidationErrors | null {
    return AOValidators.touched(control) || AOValidations.isCpfCnpj(control.value) ? null : {invalidZip: true};
  }

  static float(control: AbstractControl): ValidationErrors | null {
    return AOValidators.touched(control) || AOValidations.isFloat(control.value) ? null : {invalidNumber: true};
  }

  static floatSigned(control: AbstractControl): ValidationErrors | null {
    return AOValidators.touched(control) || AOValidations.isFloat_S(control.value) ? null : {invalidNumber: true};
  }

  static floatUnsigned(control: AbstractControl): ValidationErrors | null {
    return AOValidators.touched(control) || AOValidations.isFloat_U(control.value) ? null : {invalidNumber: true};
  }

  static int(control: AbstractControl): ValidationErrors | null {
    return AOValidators.touched(control) || AOValidations.isInt(control.value) ? null : {invalidNumber: true};
  }

  static intSigned(control: AbstractControl): ValidationErrors | null {
    return AOValidators.touched(control) || AOValidations.isInt_S(control.value) ? null : {invalidNumber: true};
  }

  static intUnsigned(control: AbstractControl): ValidationErrors | null {
    return AOValidators.touched(control) || AOValidations.isInt_U(control.value) ? null : {invalidNumber: true};
  }

}
